import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

const IncompleteTrips = React.lazy(() => import("./IncompleteTrips"));
const IssueBucketsMain = React.lazy(() => import("./Issues"));
const ManageDuties = React.lazy(() => import("./ManageDuties"));
const TripDetails = React.lazy(() => import("./ManageDuties/TripDetails"));
const GeneralSettings = React.lazy(() => import("./Settings/GeneralSettings"));
const BillingRules = React.lazy(() => import("./Settings/BillingRules"));
const DutySetting = React.lazy(() => import("./Settings/DutySetting"));
const BillingReports = React.lazy(() => import("./BillingReports"));
const VendorDrillDown = React.lazy(() => import("./BillingReports/VendorDrillDown"));
const TripUnderDuty = React.lazy(() => import("./BillingReports/TripUnderDuty"));
const CustomReports = React.lazy(() => import("./CustomReports"));
const RateList = React.lazy(() => import("../ManageRateCard/RateCardListing"));
const RateCreate = React.lazy(() => import("../ManageRateCard/RateCard"));
const GarageMaster = React.lazy(() => import("../Master/Garage"));
const ZoneMaster = React.lazy(() => import("../Master/Zone"));

export const BillingMNoduleConfig = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/incomplete-trips",
    element: <IncompleteTrips />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/issue-buckets",
    element: <IssueBucketsMain />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/manage-duties",
    element: <ManageDuties />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/manage-duties/:dutyCode/trips",
    element: <TripDetails />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/general-settings",
    element: <GeneralSettings />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/billing-rules",
    element: <BillingRules />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/duty-setting",
    element: <DutySetting />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/billing-reports",
    element: <BillingReports />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/billing-reports/vendor/:vendorId",
    element: <VendorDrillDown />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/billing-reports/vendor/:vendorId/duty/:dutyId",
    element: <TripUnderDuty />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/custom-report",
    element: <CustomReports />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/rate-card-list",
    element: <RateList />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "rate-card/:id",
    element: <RateCreate />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/master/garage",
    element: <GarageMaster />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: "/master/zone",
    element: <ZoneMaster />,
  },
];
